<template>
  <div style="display: inline">

    <ag-grid-vue
      style="width: 100%; height: 300px;"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :paginationAutoPageSize="false"
      :paginationPageSize="paginationPageSize"
      :pagination="true"
      id="order_discounts"
      :gridOptions="gridOptions"
      @grid-ready="onGridReady"
      :context="context"
      :frameworkComponents="frameworkComponents"
      :defaultColDef="defaultColDef"
      :enableCellTextSelection="true"
      :ensureDomOrder="true"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import agGrid from "@/mixins/agGrid";
import { AgGridVue } from "ag-grid-vue";
import moneyFormatter from "@/mixins/moneyFormatter";
import { date } from "@/components/agGrid/cellRenderers";


export default {
  name: "OrderDiscountsTable",
  components: {
    AgGridVue,
  },
  props: {
    phase3d_care_app: {
      type: Boolean,
      required: true,
    },
  },
  filters: {
    currency: val => {
      return moneyFormatter.format(val);
    }
  },
  mixins: [agGrid, moneyFormatter],
  data() {
    return {
      columnDefs: null,
      rowData: null,
      paginationPageSize: 100,
      frameworkComponents: null,
      gridApi: null,
      columnApi: null,
      gridOptions: null,
      context: null,
      defaultColDef: null,
      showActionsMenu: false,
      overlayLoadingTemplate: true,
    };
  },
  computed: {
    order() {
      return this.$store.getters["orders/get"]("order");
    },
    orderWasPlacedOnShopify() {
      return [22, 23, 31, 32].indexOf(Number(this.order.CartID)) > -1;
    },
  },
  beforeMount() {
    this.gridOptions = {
      headerHeight: 30,
      rowHeight: 30,
      pagination: false,
      suppressPaginationPanel: true,
      rowSelection: "single",
      rowDeselection: true,
    };

    this.context = { componentParent: this };

    this.defaultColDef = {
      sortable: true,
      filter: true,
      flex: 0,
      suppressMovable: false,
      width: 160
    };

    this.columnDefs = [
      {
        headerName: "SKU",
        field: "SKU",
        width: 150
      },
      {
        headerName: "Product",
        field: "Product",
        width: 300
      },
      {
        headerName: "Item Number",
        field: "item_number",
        width: 150
      },
      {
        headerName: "Title",
        field: "title",
        width: 150
      },
      {
        headerName: "Code",
        field: "code",
        width: 150
      },
      {
        headerName: "Description",
        field: "description",
        width: 150
      },
      {
        headerName: "Discount Type",
        field: "discount_type",
        width: 150
      },
      {
        headerName: "Target Type",
        field: "target_type",
        width: 150
      },
      {
        headerName: "Target Selection",
        field: "target_selection",
        width: 150
      },
      {
        headerName: "Discount Value",
        field: "discount_value",
        width: 150
      },
      {
        headerName: "Discount Value Type",
        field: "discount_value_type",
        width: 150
      },
      {
        headerName: "Allocation Method",
        field: "allocation_method",
        width: 150
      },
      {
        headerName: "Created At",
        field: "created_at",
        width: 150
      },
    ];

    if (this.phase3d_care_app) {
      // Remove SKU and Product columns
      this.columnDefs = this.columnDefs.filter(
        column => column.field !== "SKU" && column.field !== "Product"
      );

      this.columnDefs = [
        {
          headerName: "Variant",
          width: 100,
          valueGetter: (params) => {
            return params.data.variant_id;
          }
        },
        {
          headerName: "Product",
          width: 200,
          valueGetter: (params) => {
            return params.data.variant.product.name;
          },
          tooltipValueGetter: (params) => {
            return params.data.variant.product.name;
          }
        },
        {
          headerName: "Size",
          valueGetter: (params) => {
            return params.data.variant.variant_name;
          }
        },
        ...this.columnDefs
      ];
    }

    this.frameworkComponents = {
      dateCell: date
    };
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
    this.$store
      .dispatch("orders/fetchDiscounts", this.order.SourceOrderNumber)
      .then(() => {
        this.rowData = this.order.discounts;
      });
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady() {},
    toggleSlideover(component, title, properties = {}) {
      if (component) {
        this.slideoverComponent = component;
        this.slideoverTitle = title;
        this.slideoverProperties = properties;
      }

      setTimeout(() => {
        this.slideoverVisible = ! this.slideoverVisible;
      }, 3);
    },
    refreshOrder() {
      this.$router.go(0);
    },
  }
};
</script>
<style lang="scss">
@import "../../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
@import "../../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";

.link {
  @apply ml-0 text-green-600 transition duration-150 ease-in-out;
}

.link:hover {
  @apply text-green-500 underline;
}
</style>
